var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiomarkerReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.943,
    height: 9.787,
    viewBox: "0 0 17.943 9.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down_Arrow_3_",
    d: "M28.971,40a.813.813,0,0,0-.577.239l-8.156,8.156a.815.815,0,1,0,1.153,1.153l7.579-7.579,7.579,7.579A.815.815,0,1,0,37.7,48.395l-8.156-8.156A.813.813,0,0,0,28.971,40Z",
    transform: "translate(-20 -40)",
    fill: "#e68413"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiomarkerReport);
export default __webpack_public_path__ + "static/media/biomarkerReport.fdfd8d1e96c9a96e4b0bb00fd76392d8.svg";
export { ForwardRef as ReactComponent };